export * from './information.component';
export * from './information.module';
